import { RecurringContributionItem } from "@components/Modals/BankRelinkModal/components/RecurringContributionItem";
import { useStyles } from "@components/Modals/BankRelinkModal/styles";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { i18n, Translations } from "@i18n";

export const ResumeContributions = () => {
  const styles = useStyles();

  return (
    <>
      <Spacing size={SpacingSizes.XL} />

      <RecurringContributionItem />
      <Spacing size={SpacingSizes.XL} />

      <H2 style={styles.title}>{i18n.t(Translations.BankRelinkModalResumeContributionsTitle)}</H2>
      <Spacing size={SpacingSizes.M} />
      <Body style={styles.subtitle}>
        {i18n.t(Translations.BankRelinkModalResumeContributionsSubtitle)}
      </Body>
      <Spacing size={SpacingSizes.M} />
    </>
  );
};
